import { FunctionComponent, PropsWithChildren, useMemo } from 'react';

import { mapModelEntityToItemLabelModel } from '../../../../../features/firmware-management/utils/mapping/mapping.util';
import { castTo } from '../../../../../features/shared/utils/cast-to';
import { getModelsByBrand } from '../../../../thunks/get-models-by-brand/get-models-by-brand.thunk';
import { withOptions } from '../../../with-options/with-options';
import { ModelsDropdownProps } from '../../types/models-dropdown-props.type';

const withModelsOptions = (
  Component: FunctionComponent<ModelsDropdownProps>
): FunctionComponent<ModelsDropdownProps> => {
  return (props: PropsWithChildren<ModelsDropdownProps>) => {
    const selectedBrand = props.campaignSelectFilters?.brandId;
    const brandId = selectedBrand
      ? castTo<number>(selectedBrand)
      : props.values.brandId?.id;

    const WrappedComponent = useMemo(
      () =>
        withOptions(Component, {
          dispatchFn: getModelsByBrand,
          mapper: mapModelEntityToItemLabelModel,
          thunkArgs: {
            brandId,
          },
        }),
      [brandId]
    );

    return <WrappedComponent {...props} />;
  };
};

export default withModelsOptions;
